import styled from "styled-components"
import { lighten } from "polished"
import { TERTIARY_COLOR } from "../../utils/colors"

export default styled.footer`
  padding: 2rem 0;
  background: ${lighten(0.04, TERTIARY_COLOR)};
`
